import { render, staticRenderFns } from "./WCabdetails.vue?vue&type=template&id=2c217fcb&scoped=true"
import script from "./WCabdetails.vue?vue&type=script&lang=js"
export * from "./WCabdetails.vue?vue&type=script&lang=js"
import style0 from "./WCabdetails.vue?vue&type=style&index=0&id=2c217fcb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c217fcb",
  null
  
)

export default component.exports